import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IaithStorfaService {

  private storfaIaithSubject = new BehaviorSubject<string | null>(null);
  public readonly storfaIaith$ = this.storfaIaithSubject.asObservable();

  private readonly storageKey = 'asedaufflyd:iaith::';

  constructor() { }

  setio(key: string, data: any) {
    // Normalize to a string for comparison
    const value = (typeof data === 'string') ? data : JSON.stringify(data);

    // If value already in storage, do nothing (avoid emitting duplicate events)
    const existing = localStorage.getItem(`${this.storageKey}${key}`);
    if (existing === value) {
      return;
    }

    localStorage.setItem(`${this.storageKey}${key}`, value);
    this.storfaIaithSubject.next(key);
  }

  nol(key: string): string {
    return localStorage.getItem(`${this.storageKey}${key}`);
  }

  tynnu(key: string) {
    localStorage.removeItem(`${this.storageKey}${key}`);
    this.storfaIaithSubject.next(key);
  }
}